import React from 'react';
import { getLinksComponent } from '../ShareSection.js';
export const ShareModal = ({ href, heading, description }) => {
	const { TwitterLink, FacebookLink, LinkedInLink } = getLinksComponent({
		href,
		heading,
		description,
	});
	return {
		title: 'Share this page:',
		FooterComponent: () => {
			return (
				<ul className="flex items-center justify-center">
					<li className="mx-1">
						<TwitterLink />
					</li>
					<li className="mx-1">
						<FacebookLink />
					</li>
					<li className="mx-1">
						<LinkedInLink />
					</li>
				</ul>
			);
		},
	};
};
